import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.notice.item');
import { OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import $ from "jquery";
import moment from "moment";
import showdown from 'showdown';
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-gsdcadmin-notice-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.notice.item/view.scss */
/* src/app/portal.gsdcadmin.notice.item/view.scss: no such file or directory */`],
})
export class PortalGsdcadminNoticeItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() post_id: any;
    @Input() category: any;

    @ViewChild('editor')
    public editorElement: ElementRef;
    public comments: any = [];
    public comment_text: any = '';
    public commentFiles: any = [];

    public notice: any = {};
    public editor: any;

    public status = [
        { label: '초안', value: 'draft' },
        { label: '게시', value: 'publish' }
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership('admin', "/");
        await this.load();
        await this.buildEditor();
        await this.service.loading.hide();
    }

    public async load() {
        if (this.post_id != 'new') {
            const { code, data } = await wiz.call("get", { id: this.post_id });
            if (code != 200) return await this.service.alert.error("Error!");

            // this.notice = data.item;
            // this.notice.extra = JSON.parse(this.notice.extra.replace(/'/g, '"'));
            // this.notice.created = moment(this.notice.created).format("YYYY-MM-DD");
            // this.notice.updated = moment(this.notice.updated).format("YYYY-MM-DD");
            this.notice = {
                ...data.item,
                status: (data.item?.status || 'draft').trim(),
                extra: JSON.parse((data.item.extra || "[]").replace(/'/g, '"')),
                created: moment(data.item.created).format("YYYY-MM-DD"),
                updated: moment(data.item.updated).format("YYYY-MM-DD"),
            };
            this.comments = data.comments;
        } else {
            this.notice = {
                category: this.category,
                type: 'public',
                title: '',
                content: '',
                level: '일반',
                status: 'draft',
                extra: [],
                created: moment().format("YYYY-MM-DD")
            };
        }

        await this.service.render();
    }

    public async buildEditor() {
        let editor = this.editor = await ClassicEditor.create(document.querySelector("textarea#editor"), {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                shouldNotGroupWhenFull: true
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar", "Markdown"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });

        this.editor.data.set(this.notice.content);

        await this.service.render();
    }

    public showdown(text) {
        const markdown = typeof text === 'string' ? text : '';
        let converter = new showdown.Converter();
        return converter.makeHtml(markdown);
    }

    public async update() {
        if (this.notice.title == "") return await this.service.alert.error("제목을 입력해주세요.");
        if (this.tab == 'text') this.changeTab('editor')
        this.notice.content = this.editor.data.get();
        this.notice.category = "notice"
        let data: any = JSON.stringify(this.notice);
        const { code } = await wiz.call("update", { data: data });
        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.alert.success('저장되었습니다');

        if (!this.notice.id) {
            this.router.navigateByUrl('/admin/notice');
        }
    }

    public tab = "editor";
    public changeTab(tab) {
        if (tab === "editor") {
            this.editor.data.set(this.notice.content);
        }
        this.tab = tab;
        this.service.render();
    }

    public async delete() {
        let res: any = await this.service.alert.error("정말로 삭제하시겠습니까?", "취소", "삭제");
        if (!res) return;
        const { code } = await wiz.call("delete", { id: this.notice.id });
        if (code != 200) return await this.service.alert.error("Error!");
        // await this.service.href(`/admin/notice/${this.category}`);
        this.router.navigateByUrl('/admin/notice');
    }

    public fd = new FormData();
    public async fileUpload(e) {
        if (!this.notice.extra) this.notice.extra = [];
        for (let i = 0; i < e.target.files.length; i++) {
            let file = e.target.files[i]
            this.filename = file.name;
            if (!file.filepath) file.filepath = file.name;
            this.fd.append('upload', file);
            let fdurl = '/file/upload';
            const { url } = await this.service.file.upload(fdurl, this.fd, async (percent: number, total: number, position: number) => { });
            let fileInfo = { name: file.name, size: file.size, url: url }
            this.notice.extra.push(fileInfo);
        }
        await this.service.render();
    }

    public async removeAttachment(index: number) {
        this.notice.extra = this.notice.extra.filter((_, i) => i !== index);
        await this.service.render();
    }

    public async removeFile(file) {
        let res: any = await this.service.alert.error("정말로 삭제하시겠습니까?", "취소", "삭제");
        if (!res) return;
        this.notice.extra.remove(file);
        this.service.render();
    }

    public async commentWrite(comment: any) {
        if (!comment) return await this.service.alert.warning("댓글을 작성해주세요.");
        this.newComment = comment;
        const { code, data } = await wiz.call("commentWrite", { notice_id: this.post_id, comment: this.newComment });
        if (code != 200) return await this.service.alert.error("Error!");
        this.newComment = "";
        await this.load();
    }

    public async removeComment(comment) {
        let res = await this.service.alert.error("댓글을 삭제하시겠습니까?", "닫기", "삭제");
        if (!res) return;
        const { code } = await wiz.call("remove_comment", comment);
        if (code != 200) return await this.service.alert.error("Error!");
        await this.load();
    }

    public formatFileSize(bytes: number) {
        if (!Number.isFinite(bytes)) return '-';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0, size = bytes;
        while (size >= 1024 && i < units.length - 1) { size /= 1024; i++; }
        return `${Math.round(size * 100) / 100} ${units[i]}`;
    }

    public getFileIcon(filename: string) {
        const ext = this.getExt(filename);
        switch (ext) {
            case 'pdf': return '📕';
            case 'doc':
            case 'docx': return '📝';
            case 'xls':
            case 'xlsx': return '📊';
            case 'ppt':
            case 'pptx': return '📈';
            case 'txt': return '📄';
            case 'png':
            case 'jpg':
            case 'jpeg':
            case 'gif':
            case 'webp': return '🖼️';
            default: return '📦';
        }
    }

    private getExt(name: string): string | null {
        const i = name.lastIndexOf('.');
        return i >= 0 ? name.slice(i + 1).toLowerCase() : null;
    }

}

export default PortalGsdcadminNoticeItemComponent;